"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));

// eslint-disable-next-line
var context = /*#__PURE__*/_react["default"].createContext({});
if (typeof document !== 'undefined') {
  context = /*#__PURE__*/_react["default"].createContext(window.__routeInfo);
}
var _default = context;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2NvbnRleHQvc3RhdGljSW5mb0NvbnRleHQuanMiXSwibmFtZXMiOlsiY29udGV4dCIsIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsImRvY3VtZW50Iiwid2luZG93IiwiX19yb3V0ZUluZm8iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVBO0FBQ0EsSUFBSUEsT0FBTyxnQkFBR0Msa0JBQU1DLGFBQU4sQ0FBb0IsRUFBcEIsQ0FBZDs7QUFFQSxJQUFJLE9BQU9DLFFBQVAsS0FBb0IsV0FBeEIsRUFBcUM7QUFDbkNILEVBQUFBLE9BQU8sZ0JBQUdDLGtCQUFNQyxhQUFOLENBQW9CRSxNQUFNLENBQUNDLFdBQTNCLENBQVY7QUFDRDs7ZUFFY0wsTyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lXG5sZXQgY29udGV4dCA9IFJlYWN0LmNyZWF0ZUNvbnRleHQoe30pXG5cbmlmICh0eXBlb2YgZG9jdW1lbnQgIT09ICd1bmRlZmluZWQnKSB7XG4gIGNvbnRleHQgPSBSZWFjdC5jcmVhdGVDb250ZXh0KHdpbmRvdy5fX3JvdXRlSW5mbylcbn1cblxuZXhwb3J0IGRlZmF1bHQgY29udGV4dFxuIl19
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/context/staticInfoContext.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/context/staticInfoContext.js");
  }
}();